import { defineComponent as _defineComponent } from 'vue'
import { BottomSheet } from '@travelata-libs/ui-kit';
  import { useViewport } from '@travelata-libs/utils';
  import { ref, computed } from 'vue';
  import Button from '@ve/components/button/desktop/Button.vue';
  import DialogWrapperDesktop from '@ve/components/dialogWrapper/desktop/DialogWrapperDesktop.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CashbackModal',
  setup(__props, { expose }) {

  const { isMobile } = useViewport();
  const isOpen = ref(false);
  const dialogRef = ref<InstanceType<typeof DialogWrapperDesktop> | null>(null);

  const conditions: string[] = [
    'Акция действует на все направления и любые даты путешествия',
    'Кешбэк начисляется на всю сумму оплаты, включая дополнительные услуги (например, трансфер, страховку или другие опции)',
    'Размер кешбэка — 5%, но не более 7 000 ₽ за одну оплату',
    'Кешбэк начисляется после подтверждения бронирования.',
    'Срок начисления — до 7 рабочих дней после подтверждения и списания средств.',
  ];

  const steps: string[] = [
    'Выберите тур или отель от туроператора Travelata с пометкой «Кешбэк 5%».',
    'Перейдите к оформлению и оплатите бронирование зарегистрированной картой «Мир».',
    'Получите кешбэк на карту после подтверждения бронирования в течение 3–7 рабочих дней.',
  ];

  const openConditionsLink = (): void => {
    window.open(
      'https://vamprivet.ru/promo/puteshestviya-i-otdyh/otkryvayte-novye-strany-s-travelata/',
      '_blank',
      'noopener',
    );
  };

  const lockScroll = (): void => {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  };

  const unlockScroll = (): void => {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  };

  const open = (): void => {
    if (isMobile.value) {
      isOpen.value = true;
    } else if (dialogRef.value) {
      lockScroll();
      dialogRef.value.open();
    }
  };

  const close = (): void => {
    if (isMobile.value) {
      isOpen.value = false;
    } else if (dialogRef.value) {
      dialogRef.value.close();
    }
  };

  const conditionsTextButton = computed(() => {
    return isMobile ? 'Подробнее' : 'Подробные условия акции';
  })

  expose({
    open,
    close,
  });

return { __sfc: true,isMobile, isOpen, dialogRef, conditions, steps, openConditionsLink, lockScroll, unlockScroll, open, close, conditionsTextButton, BottomSheet, Button, DialogWrapperDesktop }
}

})